import { Card, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import CancelSubscription from "./cancel-subscription";
import { formatCurrency, toCapital } from "@/utils/utils";
import type { SubscriptionInformationCardProps } from "../musio-plus";

export const PausedCard: React.FC<SubscriptionInformationCardProps> = ({ recurringStatus }) => {

  return (
    <Card className="relative max-w-[373px] w-full flex flex-col space-y-8 justify-between bg-musio-bg p-4">
      <Check className="absolute top-5 right-2 h-3 w-3 font-extrabold text-black bg-musio-green rounded-full" />
      <CardHeader className="p-0">
        <CardTitle className="flex flex-col items-center align-middle justify-center">
          <p className="text-xl font-semibold text-center text-musio-orange">Paused</p>
          <p className="text-center font-semibold text-lg text-lilac">{toCapital(recurringStatus.plan!)}</p>
          <p className="text-center font-normal text-sm text-musio-orange">Reactivates {recurringStatus.resumes}</p>
        </CardTitle>
      </CardHeader>

      <CardFooter className="flex flex-col gap-0">
        <p className="font-semibold text-lg text-lilac p-0">
          {recurringStatus.plan == "monthly" ?
            `${formatCurrency(recurringStatus.amount!, recurringStatus.currency!)} / month` :
            `${formatCurrency(recurringStatus.amount!, recurringStatus.currency!)} / year`
          }
        </p>
        <CancelSubscription className="mt-0 p-0" />
      </CardFooter>
    </Card>
  );
};
